import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Grid, Row, Col } from 'react-bootstrap';

import { setFilters } from 'actions/SalesActivityDashboardActions';
import { parseQs, stringifyQs } from 'helpers/http';

import DocMeta from 'components/DocMeta';
import List from 'components/List';

import RadActivityList from 'components/layout/rad/RadActivityList';
import RadCarList from 'components/layout/rad/RadCarList';

import Pagination from 'components/layout/Pagination';
import Loader from 'components/layout/Loader';

class RentActivityDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialised: true,
    };
  }

  onCarSelect = vin => {
    const { history, location, setFilters } = this.props;

    const query = parseQs(location.search);
    query.vin = [vin];
    history.push({ pathname: location.pathname, search: stringifyQs(query) });
    setFilters(query);
  };

  render() {
    const { location, activityList, carList } = this.props;
    const { initialised } = this.state;

    const urlData = { filters: { ...parseQs(location.search) } };

    // TODO: Car grouped list + Chart

    return initialised ? (
      <DocMeta tags={[{ name: 'title', content: 'Rent Activity Dashboard' }]}>
        <div class="p-t-20">
          <List
            noRender
            listName="activityList"
            url="/api/plugin/rentActivityDashboard/activities.json"
            urlData={urlData}
            list={activityList}
          />
          <List
            noRender
            listName="carList"
            url="/api/plugin/rentActivityDashboard/cars.json"
            urlData={urlData}
            list={carList}
          />

          <Grid fluid>
            {!carList.pending ? (
              <Row>
                <Col xs={9} class="p-b-30">
                  <RadCarList
                    selectedCarList={urlData.filters.vin}
                    carList={carList.data.list}
                    onSelect={this.onCarSelect}
                  />
                  {carList.data.count > 0 ? (
                    <Pagination
                      count={carList.data.count}
                      resPerPage={carList.resPerPage}
                      activePage={carList.activePage}
                      handleSelect={this.handlePagination}
                    />
                  ) : (
                    <Row>
                      <Col md={12}>
                        <div>Keine Daten vorhanden</div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            ) : (
              <div class="p-t-50 p-b-50">
                <Loader />
              </div>
            )}
            {!activityList.pending ? (
              <Row>
                <Col xs={12} class="p-b-30">
                  <RadActivityList activityList={activityList.data.list} />

                  {activityList.data.count > 0 ? (
                    <Pagination
                      count={activityList.data.count}
                      resPerPage={activityList.resPerPage}
                      activePage={activityList.activePage}
                      handleSelect={this.handlePagination}
                    />
                  ) : (
                    <Row>
                      <Col md={12}>
                        <div>Keine Daten vorhanden</div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            ) : (
              <div class="p-t-50 p-b-50">
                <Loader />
              </div>
            )}
          </Grid>
        </div>
      </DocMeta>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    projectConfig: state.data.projectConfig,
    activityList: state.list.activityList,
    carList: state.list.carList,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setFilters: filters => {
      dispatch(setFilters(filters));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(RentActivityDashboard)
  )
);
